import * as React from "react";
import type { SVGProps } from "react";
const CrunchbaseBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.1671 12.5446c0 .0136.0008.0296.0008.0456 0 1.1619-.9419 2.1038-2.1039 2.1038s-2.1038-.9419-2.1038-2.1038.9419-2.1039 2.1038-2.1039c.3817 0 .7402.1017 1.0491.2801l-.0104-.0056c.6274.3609 1.0475 1.0219 1.0652 1.7814zm.2224 2.7656a3.54 3.54 0 0 1-1.0355.6218l-.024.008c-.3953.1576-.8531.2497-1.3316.2497a3.66 3.66 0 0 1-2.071-.6378l.0128.008v.3801h-1.5101V5.3696h1.4997v4.11c.5073-.3473 1.1227-.5753 1.7869-.629l.0136-.0008h.2753c2.027 0 3.6699 1.6429 3.6699 3.67 0 1.1147-.4969 2.1126-1.2812 2.7856zm-11.345-.8451c.2569.1201.5578.1897.8747.1897.8482 0 1.5796-.5002 1.915-1.222l.0056-.0128h1.6596c-.4073 1.6285-1.8573 2.8153-3.585 2.8153-2.0382 0-3.69-1.6517-3.69-3.6899s1.6526-3.69 3.69-3.69c1.7277 0 3.1777 1.1868 3.5794 2.7897l.0056.0256H9.8398c-.341-.7346-1.0724-1.2348-1.9198-1.2348-1.1652 0-2.1103.9451-2.1103 2.1103 0 .8482.5002 1.5796 1.222 1.9149l.0128.0056zM21.6001 0H2.3999C1.0763.0056.0056 1.0771 0 2.3991v19.201C.0056 22.9237 1.0771 23.9944 2.3991 24h19.201c1.3236-.0056 2.3943-1.0771 2.3999-2.3991V2.3999C23.9944 1.0763 22.9221.0056 21.6001 0"
    />
  </svg>
);
export default CrunchbaseBlack;
